import { render, staticRenderFns } from "./carouselBase.vue?vue&type=template&id=1d6d69d2&"
import script from "./carouselBase.vue?vue&type=script&lang=js&"
export * from "./carouselBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1d6d69d2', component.options)
    } else {
      api.reload('1d6d69d2', component.options)
    }
    module.hot.accept("./carouselBase.vue?vue&type=template&id=1d6d69d2&", function () {
      api.rerender('1d6d69d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/Common/Scripts/Components/carouselBase.vue"
export default component.exports